import { Box } from '@mui/material';
import React from 'react';

export default function Card({ children }) {
  return (
    <Box p={2} bgcolor="grey.50" border="1px solid" borderColor="grey.300" borderRadius="8px">
      {children}
    </Box>
  );
}
